import { createStore } from "./createStore";

const base = (set) => ({
  // UI state
  captionsOpen: true,
  currentCaptions: [],
  isScratchPadOpen: false,
  isScratchPadAvailable: false,
  isBottomBarExpanded: false,
  showKeyboardGuide: false,
  isCalculatorOpen: false,
  isCalculatorAvailable: false,
  canvasAccess: {
    enabled: false,
    allowed: false,
    reason: "uninitialized",
  },

  activeAssessmentModal: null,
  postAssessmentSlideIndex: null,
  isNamePronunciationModalOpen: false,
  showExitLessonModal: false,
  exitLessonPending: false,
  showLessonCompleteModal: false,
  lessonCompleteVariant: null,
  lessonExitCommitted: false,
  lessonEndGeneration: 0,
  lessonLeaveGuardArmed: false,

  lastAgentResponse: "",
  captionsFrozen: false,
  captionsExpanded: false,
  captionsSnapshots: [],

  // UI Actions
  setCaptionsOpen: (val) => set({ captionsOpen: val }),
  setCurrentCaptions: (val) => set({ currentCaptions: val }),
  setLastAgentResponse: (text) => set({ lastAgentResponse: text }),
  addCaptionsSnapshot: (words) =>
    set((state) => ({
      captionsSnapshots: [...state.captionsSnapshots, words],
    })),
  clearCaptionsSnapshots: () => set({ captionsSnapshots: [] }),
  setCaptionsFrozen: (val) => set({ captionsFrozen: val }),
  setCaptionsExpanded: (val) => set({ captionsExpanded: val }),
  setIsScratchPadOpen: (val) => set({ isScratchPadOpen: val }),
  setIsScratchPadAvailable: (val) => set({ isScratchPadAvailable: val }),
  setIsBottomBarExpanded: (val) => set({ isBottomBarExpanded: val }),
  setShowKeyboardGuide: (val) => set({ showKeyboardGuide: val }),
  setIsCalculatorOpen: (val) => set({ isCalculatorOpen: val }),
  setIsCalculatorAvailable: (val) => set({ isCalculatorAvailable: val }),

  setCanvasAccess: (canvasAccess) => set({ canvasAccess }),

  setActiveAssessmentModal: (type) => set({ activeAssessmentModal: type }),
  setIsNamePronunciationModalOpen: (val) =>
    set({ isNamePronunciationModalOpen: val }),
  setPostAssessmentSlideIndex: (idx) => set({ postAssessmentSlideIndex: idx }),
  setShowExitLessonModal: (val) => set({ showExitLessonModal: val }),
  setExitLessonPending: (val) => set({ exitLessonPending: val }),

  openLessonComplete: (variant) =>
    set({ showLessonCompleteModal: true, lessonCompleteVariant: variant }),
  closeLessonComplete: () =>
    set({ showLessonCompleteModal: false, lessonCompleteVariant: null }),
  commitLessonExit: () =>
    set((s) => ({
      showExitLessonModal: false,
      exitLessonPending: false,
      lessonExitCommitted: true,
      lessonEndGeneration: s.lessonEndGeneration + 1,
    })),
  setLessonLeaveGuardArmed: (val) => set({ lessonLeaveGuardArmed: val }),
  resetLessonEndState: () =>
    set((s) => ({
      showExitLessonModal: false,
      exitLessonPending: false,
      showLessonCompleteModal: false,
      lessonCompleteVariant: null,
      lessonExitCommitted: false,
      // Session IDs are reused when the same lesson is reopened.
      lessonEndGeneration: s.lessonEndGeneration + 1,
    })),
});

export const useUIStore = createStore("UIStore", base);
